const STYLES = {
  emerald: { pill: "bg-emerald-50 text-emerald-700", dot: "bg-emerald-500" },
  amber:   { pill: "bg-amber-50 text-amber-700",     dot: "bg-amber-500" },
  blue:    { pill: "bg-blue-50 text-blue-700",       dot: "bg-blue-500" },
  red:     { pill: "bg-red-50 text-red-700",         dot: "bg-red-500" },
  slate:   { pill: "bg-slate-100 text-slate-500",    dot: "bg-slate-400" },
};

const StatusBadge = ({ color = "slate", children }) => {
  const s = STYLES[color] ?? STYLES.slate;
  return (
    <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium ${s.pill}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${s.dot}`} />
      {children}
    </span>
  );
};

export default StatusBadge;
